import { Dispatch, useCallback } from "react";
import { HeldEmailQueueAction } from "../../../hooks/admin/useHeldEmailQueueState";
import { HeldEmailDetailDrawer } from "./HeldEmailDetailDrawer";

interface Props {
  detailId: string | null;
  dispatch: Dispatch<HeldEmailQueueAction>;
}

export function HeldEmailQueueDetail({ detailId, dispatch }: Props) {
  const handleClose = useCallback(
    () => dispatch({ type: "detail", value: null }),
    [dispatch]
  );
  return (
    <HeldEmailDetailDrawer
      heldEmailId={detailId}
      onClose={handleClose}
      opened={Boolean(detailId)}
    />
  );
}
